module.exports = __webpack_public_path__ + "img/spalteloeschen.4ea0501.svg";